module.exports = __webpack_public_path__ + "static/media/up-min-globas.f8142e4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/economy/up-min-globas.svg
// module id = 336
// module chunks = 0